import "./index.less";

import { Input } from "antd";
import React, { Fragment } from "react";
import { useTranslate } from "@obsbot/remo-i18n";

export interface LoginPasswordProps {
    placeholder?: string;
    showRuleDesc?: boolean;
    onFocus?: () => void;
}

export const LoginPassword: React.FC<LoginPasswordProps> = ({
    placeholder,
    showRuleDesc,
    ...restProps
}) => {
    const t = useTranslate();
    return (
        <Fragment>
            <div className="login-password-title">
                <span>{t("login-page.password")}</span>
            </div>
            <Input.Password
                autoComplete="off"
                className="login-password"
                placeholder={placeholder}
                onKeyDown={e => {
                    if ((e.ctrlKey || e.metaKey) && e.key === "z") {
                        e.preventDefault();
                    }
                }}
                {...restProps}
            />
            {showRuleDesc ? (
                <span className="login-password-rule">{t("login-page.password-rule")}</span>
            ) : null}
        </Fragment>
    );
};
